export enum PaymentOption {
    SBP = "SBP",
    SBP_QR = "SBP_QR",
    MANUAL_SBP_QR = "MANUAL_SBP_QR",
    TO_BANK_DETAILS = "TO_BANK_DETAILS",
    TO_CARD = "TO_CARD",
    TO_ACCOUNT = "TO_ACCOUNT",
    TO_PHONE_NUMBER = "TO_PHONE_NUMBER",
    MOBILE_TOP_UP = "MOBILE_TOP_UP",
    UPI = "UPI",
    QUASI_UPI = "QUASI_UPI",
    P2C = "P2C",
    CROSS_BORDER = "CROSS_BORDER",
    TG_BOT = "TG_BOT",
    CLICK_UZ_QR = "CLICK_UZ_QR",
    TIPS = "TIPS",
    CARD_ACQUIRING = "CARD_ACQUIRING",
    CARD_ACQUIRING_REDIRECT = "CARD_ACQUIRING_REDIRECT",
    MANUAL_ECOM = "MANUAL_ECOM",
    VIET_QR = "VIET_QR",
    IND_QR = "IND_QR",
    BR_QR = "BR_QR",
    IBAN = "IBAN",
    CVU = "CVU",
    PEN_QR = "PEN_QR",
}